var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParcelSenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8604 22.8232H32.1751V24.0665H30.8604V22.8232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1191 22.8232H37.4339V24.0665H36.1191V22.8232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1113 33.9985H22.3145V35.2418H13.1113V33.9985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7412 36.6279H17.056V37.8712H15.7412V36.6279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0635 11.6123H20.3068V12.927H19.0635V11.6123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87277 26.696H15.741V25.4528H1.24329V24.0666H29.5457V22.8233H1.57814L3.6552 18.1501H30.8604V16.9068H26.8806V13.5845H25.6373V16.9068H16.3627V10.2616H20.3428V9.01863H13.3797L20.3784 2.5199V7.668H21.6216V2.5199L28.6203 9.01863H25.6373V11.6122H26.8806V10.2616H31.7861L21 0.246094L10.2139 10.2616H15.1194V16.9068H2.84706L0 23.3129V26.696H2.62949V41.8154H28.2309V40.5721H3.87277V26.696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9996 23.3129L39.1525 16.9067H32.8323V18.15H38.3444L40.7563 23.5769V25.4527H17.7129V26.696H38.1268V40.5721H30.2028V41.8154H39.3701V26.696H41.9996V23.3129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4902 22.8232H34.805V24.0665H33.4902V22.8232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1035 38.5285V33.3413H5.91602V38.5285H11.1035ZM7.1593 34.5846H9.86024V37.2852H7.1593V34.5846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1113 36.6279H14.4261V37.8712H13.1113V36.6279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7414 31.3334V28.0823H33.4902V29.3256H35.4981V31.3334H36.7414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0635 14.2417H20.3068V15.5564H19.0635V14.2417Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelSenderIcon);
export default __webpack_public_path__ + "static/media/parcel-sender-icon.3e36939b2f1eab705e6494135ec40eb1.svg";
export { ForwardRef as ReactComponent };